import * as React from "react";

import useReload from "./useReload";
import useServiceSetup from "./useServiceSetup";

function useSignOut() {
  const reload = useReload("useSignOut");
  const { teardown } = useServiceSetup();

  const signOut = React.useCallback(() => {
    teardown()
  }, [teardown, reload]);

  return signOut;
}

export default useSignOut;
